import { Trash2 } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

export interface DeleteRowButtonProps {
  onClick: () => void
}

const ContainerButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  border-radius: 0.25rem;
  opacity: 1;
  transition: border 160ms ease;

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.crimson[800]};
  }
`

const StyledTrashIcon = styled(Trash2).attrs({ size: 20 })`
  color: ${({ theme }) => theme.colors.crimson[800]};
`

export const DeleteButton: React.FC<DeleteRowButtonProps> = ({ onClick }) => {
  return (
    <ContainerButton type='button' onClick={onClick} aria-label='delete-button'>
      <StyledTrashIcon />
    </ContainerButton>
  )
}
